export const SEARCH_RESULT_LOADING = 'search-result-loading'
export const SEARCH_RESULT_EMPTY = 'search-result-empty'
export const SEARCH_RESULT_ERROR = 'search-result-error'
export const SEARCH_RESULT_JOURNAL_ERROR = 'search-result-journal-error'
export const SEARCH_RESULTS = 'search-results'
export const INVALID_SEARCH_RESULT = 'invalid-search-result'
export const CREATE_MANUAL_CITATION = 'create-manual-citation'
export const WEBSITE_SUGGESTION_LINK = 'website-suggestion-link'
export const SWITCH_JOURNAL_TYPE = 'switch-journal-type'
